import script from "./FineArts.vue?vue&type=script&setup=true&lang=js"
export * from "./FineArts.vue?vue&type=script&setup=true&lang=js"

import "./FineArts.vue?vue&type=style&index=0&id=48d0713d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d0713d"]])

export default __exports__